﻿<script>
  import { onMount } from "svelte/internal";
  import { dispatchMountEvent } from "./services";
  import moment from "moment";
  import Icon from "./Icons.svelte";
  import RequestHistoryButton from "./RequestHistoryButton.svelte";
  import jquery from "jquery";
  import { toCurrency, toPriceCurrency } from "./services";

  export let _emitMount;
  export let accountnumber;
  export let accountnumberid;
  export let showprice;

  onMount(() => {
  if (_emitMount) {
  dispatchMountEvent();
  }
  });

  // state
  let isLoading = false;
  let accountNoAlt = "";
  let validAccountNo = "";
  let validAccountInput;
  let accountList = [];
  let errorMessage = "";

  let emptyAccount = {
  id: 0,
  saleBalance: "",
  salePrice: "",
  saleInvestment: "",
  buybackFlag: "",
  saleDate: "",
  sellerName: "",
  buyerName: "",
  customerName: "",
  bravureSegmentId: "",
  saleType: ""
  };
  let selectedAccount = emptyAccount;
  let modelElement;
  let numberOfRequestHistory = 0;

  // get default value
  if (accountnumber && accountnumberid) {
    validAccountNo = accountnumber;
    accountNoAlt = accountnumber;
    selectedAccount = {
      id: accountnumberid
    };
  }

  // account selected
  $: {
    document.dispatchEvent(
      new CustomEvent("account-validation.selected", {
        detail: selectedAccount
      })
    );

    if (selectedAccount === emptyAccount) {
      validAccountNo = "";
    } else {
      validAccountNo = accountNoAlt;
    }

    // dispatch change event
    if (validAccountInput) {
      validAccountInput.value = validAccountNo;
      validAccountInput.dispatchEvent(new Event("change"), { bubbles: true });
    }
  }
  // accountNoAlt change
  $: {
    if (accountNoAlt) {
      accountNoAltChangeHandle();
    }
  }
  // methods
  // account id change
  const accountNoAltChangeHandle = () => {
    if (accountNoAlt !== validAccountNo) {
      selectedAccount = emptyAccount;
    }
  };
  // get account details
  const getAccountList = async () => {
    // clear list
    accountList = [];
    errorMessage = "";
    // loading
    isLoading = true;
    try {
      // featch
      let response = await fetch(
        `/api/requests/account-details?ClientAccountNumber=${encodeURIComponent(
          accountNoAlt
        )}`,
        {
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json"
          }
        }
      );
      if (response.status !== 200) {
        if (response.status == 400) {
          throw "Invalid Account Number";
        } else {
          throw "Oops! Something went wrong!";
        }
      }
      const data = await response.json();
      accountList = data.accounts;
      numberOfRequestHistory = data.numberOfRequestHistory;
      // update selected record if only 1 found
      if (accountList.length === 1) {
        selectAccount(0);
      } else if (accountList.length > 1) {
        // open modal
        jquery(modelElement).modal("show");
      } else {
        errorMessage = "No account found!";
      }
    } catch (error) {
      errorMessage = error;
    }

    // hide loading
    isLoading = false;
  };

  // select account
  const selectAccount = index => {
    selectedAccount = accountList[index];
    if(numberOfRequestHistory > 0){
        setTimeout(()=>{
            jquery('#requestHistoryBtn').trigger('click');
        });
    }
  };
  // events

  const validateClickHandler = () => {
    getAccountList();
  };
</script>

<input type="hidden" name="BindingModel.AccountNumber" value={validAccountNo} />
<input
  type="hidden"
  name="BindingModel.AccountNumberId"
  value={selectedAccount.id} />

<label>
  Client account number
  <span class="text-danger">*</span>
</label>
<div class="row half-gutters row-vertical-gutters">
  <div class="col-sm">
    <div class="input-group input-group-lg">
      <input
        type="text"
        class="form-control font-weight-medium letter-spacing-2-5"
        placeholder="123456"
        bind:value={accountNoAlt}
        on:keypress={e => {
          if (e.key === 'Enter') {
            e.preventDefault();
            validateClickHandler(e);
          } else if (e.target.value !== validAccountNo) {
            selectedAccount = emptyAccount;
          }
        }} />
      <div class="input-group-append">
        <button
          type="button"
          class="btn btn-primary"
          on:click={validateClickHandler}>
          Validate
        </button>
      </div>
    </div>

    <input
      type="text"
      name="BindingModel.ClientAccount.AccountNumber"
      class="form-control form-control-hidden"
      bind:value={validAccountNo}
      bind:this={validAccountInput}
      required />
    {#if !validAccountNo.length}
      <span class="invalid-feedback">
        You need to validate the Account Number before you can submit the
        request.
      </span>
    {/if}
  </div>
  <div class="col-auto">
    <RequestHistoryButton
      disabled={validAccountNo.length <= 0}
      accountId={validAccountNo} />
  </div>
</div>
<div class="pt-3" />
<div
  class="panel-group panel-group--readonly loading-panel-container spinner-sm"
  class:loading={isLoading || errorMessage.length}>
  {#if isLoading}
    <div class="loading-panel loading-panel-inline loading-panel-box">
      <div class="loading-panel-content">
        <div class="loading-panel-icon">
          <div class="lds-ring">
            <div />
            <div />
            <div />
            <div />
          </div>
        </div>
        <div class="loading-panel-heading">Querying Database</div>

      </div>
    </div>
  {/if}
  {#if errorMessage.length}
    <div class="loading-panel loading-panel-inline loading-panel-box">
      <div class="loading-panel-content">
        <div class="loading-panel-heading font-weight-medium">
          {errorMessage}
        </div>

      </div>
    </div>
  {/if}
  <div class="row half-gutters row-vertical-gutters">
    <div class="col-md-6">
      <div class="data-item">
        <div class="data-name">Sales Date:</div>
        <div class="data-value">
          {selectedAccount.saleDate ? moment(selectedAccount.saleDate).format('DD/MM/YYYY') : ''}
        </div>
      </div>
      <div class="data-item">
        <div class="data-name">Seller Name:</div>
        <div class="data-value">{selectedAccount.sellerName}</div>
      </div>
      <div class="data-item">
        <div class="data-name">Buyer Name:</div>
        <div class="data-value">{selectedAccount.buyerName}</div>
      </div>
      <div class="data-item">
        <div class="data-name">Customer Name:</div>
        <div class="data-value">{selectedAccount.customerName}</div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="data-item">
        <div class="data-name">Sale Balance:</div>
        <div class="data-value">{toCurrency(selectedAccount.saleBalance)}</div>
      </div>
      <div class="data-item">
        <div class="data-name">Sale Price:</div>
        <div class="data-value">{showprice?toPriceCurrency(selectedAccount.salePrice, 6):'-'}</div>
      </div>
      <div class="data-item">
        <div class="data-name">Sale Investment:</div>
        <div class="data-value">
          {showprice?toCurrency(selectedAccount.saleInvestment):'-'}
        </div>
      </div>
      <div class="data-item">
        <div class="data-name">Buyback flag:</div>
        <div class="data-value">{selectedAccount.buybackFlag}</div>
      </div>
    </div>
  </div>
</div>

<!-- MODALS -->
<!-- Account Validation -->
<div
  class="modal fade"
  bind:this={modelElement}
  tabindex="-1"
  role="dialog"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Accounts matching {accountNoAlt}</h4>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close">

          <Icon icon="X" class="icon" />
        </button>
      </div>
      <div class="modal-body p-0">

        <table class="table table-striped table-sm table-flat">
          <thead>
            <tr>
              <th>Sale Date</th>
              <th>Seller Name</th>
              <th>Buyer Name</th>
              <th>Buyback Flag</th>
              <th>Sale Balance</th>
              <th>Sale Price</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {#each accountList as acc, i}
              <tr>
                <td class="font-weight-medium">
                  {moment(acc.saleDate).format('DD/MM/YYYY')}
                </td>
                <td>{acc.sellerName}</td>
                <td>{acc.buyerName}</td>
                <td>{acc.buybackFlag}</td>
                <td>{toCurrency(acc.saleBalance)}</td>
                <td>{showprice?toPriceCurrency(acc.salePrice, 6):'-'}</td>
                <td>
                  <a
                    href="#"
                    on:click|preventDefault={() => {
                      selectAccount(i);
                    }}
                    data-dismiss="modal">
                    Select
                  </a>
                </td>
              </tr>
            {/each}
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
